// extracted by mini-css-extract-plugin
export default {"cover":"team_cover__OhY00","heading":"team_heading__s8PYj"};